import { Helmet } from "react-helmet-async";

const SITE = "APP CHALLENGE ACADEMY";
const BASE = "https://appchallengeacademy.com";
const DEFAULT_DESC = "Déposez gratuitement votre idée d'application. Chaque semaine, APP CHALLENGE ACADEMY sélectionne un projet et développe gratuitement l'application de son créateur.";
const DEFAULT_IMAGE = `${BASE}/app-icon.png`;

export default function Seo({
  title,
  description,
  path = "/",
  lang = "fr",
  noindex = false,
  image,
  type = "website",
  publishedTime,
  keywords,
  jsonLd,
}) {
  const full = title ? `${title} — ${SITE}` : `${SITE} — Vous avez l'idée. Nous la rendons réelle.`;
  const desc = description || DEFAULT_DESC;
  const url = `${BASE}${path}`;
  const img = image || DEFAULT_IMAGE;

  const graphs = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <html lang={lang} />
      <title>{full}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />}
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="fr_FR" />
      {type === "article" && publishedTime && <meta property="article:published_time" content={publishedTime} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {graphs.map((g, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(g)}</script>
      ))}
    </Helmet>
  );
}
